import React from 'react';

const TableSkelton = ({ rowCount = 3, colCount = 8 }) => {
  return (
    <>
      {[...Array(rowCount)].map((_, rowIndex) => (
        <tr key={rowIndex}>
          {[...Array(colCount)].map((_, colIndex) => (
            <td className="text-center" key={colIndex}>
              <div className="skeleton skeleton-text" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default TableSkelton;
